"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImagePreview = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
function createImageLoader(props) {
    var image = props.reference;
    image.onload = function () {
        props.setStatus('FETCHED');
    };
    image.onerror = function () {
        props.setStatus('ERROR');
    };
    return image;
}
var enhanceImagePreview = (0, recompose_1.compose)((0, recompose_1.withState)('status', 'setStatus', 'FETCHING'), (0, recompose_1.withState)('reference', 'setReference', null), (0, recompose_1.lifecycle)({
    componentWillReceiveProps: function (nextProps) {
        if (nextProps.reference &&
            (this.props.revision !== nextProps.revision ||
                this.props.reference !== nextProps.reference)) {
            this.props.setStatus('FETCHING');
            var image = createImageLoader(nextProps);
            image.src = "".concat(__UPLOADSERVERURL__, "/files/").concat(nextProps.revision.uuid, "?preview=true&v=").concat(Math.random());
        }
    }
}), recompose_1.pure);
exports.ImagePreview = enhanceImagePreview(function (props) {
    return (React.createElement("div", { className: props.status === 'FETCHING' ? 'loader' : 'image-preview image' },
        props.status === 'FETCHING' ? React.createElement(sok_ui_1.LoadingSpinner, null) : null,
        props.status === 'ERROR' ? (React.createElement(GenericErrorMessage_1.default, { key: 'empty-folder', icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/image/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/image/thisFileIsNotCurrentlyAvailable'))) : null,
        React.createElement("div", { className: classNames('background', props.status !== 'FETCHED' ? 'hidden' : '') },
            React.createElement("img", { ref: props.setReference }))));
});
exports.default = exports.ImagePreview;
